import Header from './header';

const headerConfig = {
  name: 'siteHeader',
  class: Header,
  querySelector: {
    navToggle: '.site-header__toggle',
    nav: '.site-header__navigation',
    navContent: '.site-header__navigation__content',
    searchDropToggle: '.site-header__search-drop__toggle',
    searchDropForm: '.site-header__search-drop > form',
    superNav: '#supernav',
  },
  querySelectorAll: {
    parentMenuItem: 'ul.menu > li.menu-item-has-children',
    menuItem: 'ul.menu > li.menu-item',
  },
  options: {
    navOpenClass: 'site-header__navigation--open',
    brandingHeight: 85,
  },
};

export default headerConfig;
